export function valueOrNull<TValue extends Record<keyof TValue, unknown>>(
    value: TValue,
): TValue {
    return Object.keys(value).reduce(
        (acc: TValue, key: string) => ({
            ...acc,
            [key]: value[key as keyof TValue] || null,
        }),
        {} as TValue,
    );
}
